// External
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Injectable } from '@angular/core';
import { Location } from '@angular/common'

// Internal
import { ValuesService } from '../../values/values.service';
import { ConfigService } from '../../config/config.service';
import { SupportService } from '../process/support/support.service';
import { Subject, takeUntil } from 'rxjs';
import { MessageService } from '../core/message.service';
import { NavigationService } from '../../navigation/navigation.service';

@Injectable({ providedIn: 'root' })

export class SupportGuard {
    private readonly onDestroy$: Subject<void> = new Subject<void>();

    constructor(
        private readonly router: Router,
        private readonly navigationService: NavigationService,
        private readonly valuesService: ValuesService,
        private readonly configService: ConfigService,
        private readonly supportService: SupportService,
        private readonly messageService: MessageService,
        private readonly location: Location
    ) {
        this.messageService.getMessage()
        .pipe(takeUntil(this.onDestroy$))
        .subscribe(message => {
            if (message.text === this.valuesService.events.dataResolverDone) {
                const path = this.location.path().split("?")[0];
                if (path.includes(this.valuesService.centralPaths.support.path)) {
                    const supportNrOfLetters = this.valuesService.centralPaths.support.path.length;
                    const subpath = path.substring(supportNrOfLetters);
                    const newPath = this.activationLogic(subpath);
                    if (newPath && newPath !== path) {
                        // for the mooment this is the best slution I found, because modal container appears in link
                        // after changing the language from language modal
                        window.location.href = newPath;
                    }
                }
            }
        });
    }

    // guard to activate a route
    // asta se ruleaza doar cand nu am /:id in path sau cand calea incepe cu parental si nu se face match cu vreun copil din organiser.routes
    // daca am profile_id, il transform in hash si se reia logica din parental.organiser.routes (adica se incearca sa se faca match din nou)
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean|UrlTree {
        const subpath = route.routeConfig.path;
        const _urlProperties = this.navigationService.processUrl(route, state);
        const path = this.activationLogic(subpath);
        if (path) {
            return this.router.parseUrl(`${path}${_urlProperties.outletsString}`);
        }
        return true;
    }

    activationLogic(subpath) {
        this.supportService.displaySearchSection();
        if (subpath === this.valuesService.centralPaths.support.form.id
            && !this.configService.getSupportEmail()) {
            return this.valuesService.centralPaths["404"].path;
        } else if (subpath !== this.valuesService.centralPaths.support.id
                    && subpath !== this.valuesService.centralPaths.support.form.id
                    && !this.configService.getSupportSearch()) {
            return this.valuesService.centralPaths.support.path;
        }
        return "";
    }

}
